<p-card class="employee-card">
  @if (isForeman) {
    <i class="pi pi-user"></i>
    } {{employee.fullName}}
    &nbsp;@if (deleteable) {
    <i class="pi pi-times" style="float:right;color:red; cursor: pointer;" (click)="deleteFromContainer()"></i>
  }
  <span class="clear"></span>
</p-card>